module.exports = __webpack_public_path__ + "094d2ada902076c85c2f60b961a47b7c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-31.png
// module id = 2058
// module chunks = 0